import styled from "styled-components";

const Styles = styled.div`
  &.regist-form {
    border: 1px solid #d8dbe3;
    padding: 15px 20px;
    background: #f7f8fa;
    margin-bottom: 16px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;

    & .items,
    & .button-area {
      display: inline-flex;
      align-items: center;
      flex-wrap: wrap;
      & .ant-space {
        flex-wrap: wrap;
      }
    }

    & .button-area > * {
      margin-top: 5px;
      margin-bottom: 5px;
    }

    .button-area > button:not(:first-child) {
      margin-left: 8px;
    }

    /* label, input 요소 세트 */
    & .condition-item {
      display: inline-flex;
      flex-wrap: nowrap;
      align-items: center;
      margin-right: 16px;
      margin-top: 5px;
      margin-bottom: 5px;
      label:not([class*="ant-"]) {
        font-weight: 700;
        color: #5e6675;
        margin-right: 8px;
        flex-shrink: 0;
        min-width: 24px;
      }

      @media all and (max-width: 479px) {
        margin-right: 0px;

        & .ant-form-item .ant-select {
          width: 100% !important;
        }

        & .ant-form-item input {
          width: 100% !important;
        }
      }
    }
  }

  @media all and (max-width: 479px) {
    &.regist-form {
      padding: 10px 15px;
    }

    & .condition-item {
      width: 100%;
      & [class^="ant-"] {
        flex-grow: 1;
      }
    }

    & .button-area {
      width: 100%;
      & > button:not([class*="ant-btn-icon-only"]) {
        flex-grow: 1;
      }
    }
  }
`;

export default Styles;
